import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { PharmacistJSONAModel } from "interfaces/jsona-models/PharmacistJSONAModel";

export class PharmacistSelector extends BaseApiSelector<PharmacistJSONAModel> {
  constructor() {
    super(ResourceType.Pharmacist);
  }
}
